import React, { createContext, useContext, useState, useCallback } from 'react';

// Create UI context
const UIContext = createContext();

// UI Provider component
export function UIProvider({ children }) {
  const [isCartOpen, setIsCartOpen] = useState(false);
  
  // Open cart sidebar
  const openCart = useCallback(() => {
    setIsCartOpen(true);
  }, []);
  
  // Close cart sidebar
  const closeCart = useCallback(() => {
    setIsCartOpen(false);
  }, []);
  
  // Toggle cart sidebar
  const toggleCart = useCallback(() => {
    setIsCartOpen(prev => !prev);
  }, []);
  
  // Value to be provided by the context
  const value = {
    isCartOpen,
    openCart,
    closeCart,
    toggleCart
  };
  
  return (
    <UIContext.Provider value={value}>
      {children}
    </UIContext.Provider>
  );
}

// Custom hook to use UI context
export function useUI() {
  const context = useContext(UIContext);
  
  if (context === undefined) {
    throw new Error('useUI must be used within a UIProvider');
  }
  
  return context;
}
